import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const CreditGuides = () => {
  return (
    <LegalPageTemplate 
      title="Credit Guides"
      subtitle="CREDIT PROVIDER'S CREDIT GUIDE"
    >
      <div className="prose max-w-none">

        {/* CREDIT GUIDE START */}
        <p>
          We are required to give you this guide by law. It acknowledges your right to ask us about any assessment we may make, our financial
          services and where appropriate, the recommendation of using one credit product over another. In the unlikely event you may be
          dissatisfied with what we do or have done, this guide also provides direction on what you need to do to remedy your dissatisfaction.
        </p>

        <h3 className="font-semibold">CREDIT SUITABILITY AND ASSESSMENT</h3>
        <p>
          Before we can recommend any financial product to you, the law requires that we make an assessment of your current financial situation
          and objectives to ensure any credit product we may offer meets your needs. To do this, we will make reasonable enquiries and ask you to
          provide verifiable information directly or, where we deem it appropriate, we may obtain it from others whom we may contact. Some of
          these steps may be required by law.
        </p>
        <p>
          Please note we will not allow you to enter into a credit contract or increase a credit limit on any existing credit contract if:
        </p>
        <ol className="list-decimal pl-6">
          <li>it is likely you could not fulfil, or only do so with substantial hardship, your financial obligations to us under the contract;</li>
          <li>you could only meet your financial obligations to us by selling your family's main home;</li>
          <li>the credit contract will not meet your requirements or objectives;</li>
          <li>any regulation under the National Consumer Credit Protection Act 2009 (Cth) prohibits us from doing so.</li>
        </ol>

        <h3 className="font-semibold">ASSESSMENT COPY</h3>
        <p>
          Should you want a written copy of our assessment, free of any charge, you may ask us to provide it:
        </p>
        <ol className="list-decimal pl-6">
          <li>before you either enter into a credit contract or we increase your credit limit on any existing credit contract you may have with us; or</li>
          <li>at any time up to seven (7) years from the date you signed the contract or obtained the credit limit increase on a particular credit
            contract with us.</li>
        </ol>
        <p>
          The law imposes time limits on us giving you this information. We have seven (7) business days from when you make your request to
          supply it if your enquiry is made within two (2) years of the date you entered into the credit contract, otherwise we have twenty one (21)
          business days to do so. If we have bought your debt from your original credit provider, we have an additional eight (8) and four (4) days
          to comply.
        </p>
        <p>
          Note: - We are not obliged to give you a copy of the assessment where we do not provide you with the credit or increase the credit limit.
        </p>

        <h3 className="font-semibold">DISPUTE RESOLUTION</h3>
        <p>
          Business relationships are built through trust, openness, honesty, integrity, consistency and respect towards others. Sometimes, though,
          there may be differences of opinion, particularly when things don't quite work out the way you intended when you took out the credit
          contract. We recognise communication is the key to solving these difficulties and the steps below will assist both of us quickly get our
          relationship back on track.
        </p>
        <p>
          <strong>Step 1</strong> If you are dissatisfied with something we've done, we encourage you to phone us and explain your concern(s). We can
          usually resolve the matter(s) amicably, without delay.
        </p>
        <p>
          <strong>Step 2</strong> If you're still not happy with our response, you should contact our Internal Dispute Resolution (IDR) Manager, Claire
          Poolman by telephoning (02) 9982 1293 as soon as possible. We may ask that you put your complaint in writing to us so
          that we may investigate it further. You can email it to us on clairelawrence79@hotmail.com.
        </p>
        <p>
          <strong>Step 3</strong> Should you still be dissatisfied after using both of the above steps, you may contact our ASIC-approved External Dispute
          Resolution (EDR) provider, Australian Financial Complaints Authority. You can contact them at no cost by writing to GPO
          Box 3, Melbourne Victoria 3001, telephoning 1800 931 678 (free call), emailing info@afca.org.au, or via their website,
          https://www.afca.org.au.
        </p>
        <p>
          Please note that you must have gone through our IDR process first before doing so. If you fail to do so, the matter will be referred
          back to us to resolve in the first instance.
        </p>

        <h3 className="font-semibold">This credit guide is provided by JDP Finance Pty Ltd</h3>
        <p>
          (Authorised Credit Representative Number: 569556), an authorised credit
          representative for Strawberry Loans Pty Ltd Australian Credit Licence 519253.
        </p>
        <p>
          We are required to give you this guide by law. It acknowledges your right to ask us about any assessment we may make, our financial
          services and where appropriate, the recommendation of using one credit product over another. In the unlikely event you may be dissatisfied
          with what we do or have done, this guide also provides direction on what you need to do to remedy your dissatisfaction. It also outlines
          any fees or commissions paid by you to the authorised credit representative for acting as a credit representative.
        </p>

        <h3 className="font-semibold">Credit Suitability and Assessment (Representative)</h3>
        <p>
          Before we can recommend any financial product to you (such as a credit contract), we will make an assessment about your current
          financial situation and objectives to ensure any credit product we may offer meets your needs. We make reasonable enquiries and ask you
          to provide verifiable information.
        </p>
        <p>
          Please note that we will not allow you to enter into a credit contract if we believe:
        </p>
        <ol className="list-decimal pl-6">
          <li>it's likely you could not fulfill or only do so with substantial hardship, your financial obligations to us under the contract;</li>
          <li>you could only meet your financial objective to us by selling your family's main home;</li>
          <li>the credit contract will not meet your requirements or objectives;</li>
          <li>the National Consumer Credit Protection Act (Cth) 2009 prohibits us from doing so.</li>
        </ol>

        <h3 className="font-semibold">Assessment Copy (Representative)</h3>
        <p>
          Should you want a written copy of our assessment, free of any charge, you may ask us to provide it before you either enter into a credit
          contract with us or at any time up to seven (7) years from the date you signed the contract with us.
        </p>
        <p>
          Upon receiving a request for a copy of our assessment, we will supply it to you within seven (7) business days of making the request if
          your inquiry is made within two (2) years of the date you entered into the credit contract, otherwise we will supply it to you within twenty-one
          (21) business days. If we have bought your debt from your original credit provider, we have an additional eight (8) and four (4) days,
          respectively, to comply.
        </p>
        <p>
          We are not obliged to give you a copy of the assessment where we do not provide you with the credit.
        </p>

        <h3 className="font-semibold">Authorised Credit Representative</h3>
        <p>
          As the credit provider is an Australian Credit Licensee, it takes full responsibility for the approved credit activities it has authorised us to
          provide as its credit representative in accordance with the National Consumer Credit legislation.
        </p>
        <p>
          We are authorised to engage in credit activities on behalf of the credit provider including assessing the suitability of the provision of credit
          and exercising the rights of a credit provider in relation to a credit contract or proposed credit contract.
        </p>

        <h3 className="font-semibold">Commission</h3>
        <p>
          There are no fees or charges payable by you to us for acting as a credit representative of Strawberry Loans Pty Ltd. We do not receive any
          commission on fees and charges paid to parties other than the lender. Depending on the amount of the loan, the rate of interest and the term,
          the exact amount of commission payable to us is undeterminable.
        </p>

        <h3 className="font-semibold">Dispute Resolution</h3>
        <p>
          We believe that business relationships are built through trust, openness, honesty, integrity, consistency and respect towards others.
          Sometimes, though, there may be differences of opinion, particularly when things don't quite work out the way you intended when you
          took out the credit contract. We recognise that communication is the key to resolving these differences and the steps below will assist both
          of us quickly get our relationship back on track.
        </p>
        <p>
          <strong>Step 1</strong> If you are dissatisfied with something we've done, we encourage you to phone us and explain your concern.
          We can usually resolve the matter amicably, without delay.
        </p>
        <p>
          <strong>Step 2</strong> If you're still not happy with our response, you should contact our Internal Dispute Resolution team by
          telephoning 0425 626 605 as soon as possible. We may ask that you put your complaint in writing to us so
          that we may investigate it further. Alternatively, you can email it to us at dushyant4545@yahoo.com.
        </p>
        <p>
          <strong>Step 3</strong> Should you still be dissatisfied after using both of the above steps, you may contact our External Dispute
          Resolution provider, the Australian Financial Complaints Authority. You can contact them at no cost by
          writing to GPO Box 3 Melbourne VIC 3000, phone them on 1800 931 678 or email them at
          info@afca.org.au.
        </p>
        <p>
          Please note that you must have gone through our IDR process first before doing so. If you fail to do so, the matter will be referred
          back to us to resolve in the first instance.
        </p>

      </div>
    </LegalPageTemplate>
  );
};

export default CreditGuides;
